<template>
  <div class="filter-search-bar">
    <div v-if="showFilter" class="filter-btn" @click="$emit('filter-click')">
      <i class="el-icon-filter"></i>
      <span>筛选</span>
    </div>
    <div class="search-box">
      <el-input
        v-model="innerValue"
        :placeholder="placeholder"
        @keyup.enter.native="emitSearch"
      >
        <i
          slot="suffix"
          class="el-icon-search search-icon"
          @click="emitSearch"
        ></i>
      </el-input>
    </div>
  </div>
</template>

<script>
export default {
  name: "FilterSearchBar",
  props: {
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "搜索料号、 名称",
    },
    showFilter: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    emitSearch() {
      this.$emit("search", this.innerValue);
    },
  },
};
</script>

<style scoped lang="less">
.filter-search-bar {
  // width: 1190px;
  // margin: 0 auto;
  margin-top: -70px;
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: flex-end;
  .filter-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 6px 18px;
    border-radius: 4px;
    border: 1px solid #e4e7ed;
    background: #ffffff;
    font-size: 14px;
    color: #606266;
    cursor: pointer;
    transition: all 0.2s;

    i {
      font-size: 14px;
    }

    &:hover {
      border-color: #4286f5;
      color: #4286f5;
      background: #f4f7ff;
    }
  }

  .search-box {
    width: 420px;

    .search-icon {
      cursor: pointer;
      color: #c0c4cc;
      font-size: 22px;
      display: flex;
      align-items: center;
      height: 100%;
    }
  }
}
</style>
